import { render, staticRenderFns } from "./Control.vue?vue&type=template&id=32509c7b&scoped=true"
import script from "./Control.vue?vue&type=script&lang=js"
export * from "./Control.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32509c7b",
  null
  
)

export default component.exports